var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { ImageBase } from '@/components/ui/Image/ImageBase';
import { useBoolState } from '@/hooks/state/useBoolState';
/**
 * ホバー時に画像を強調ズームするコンポーネント
 * @param props
 * @constructor
 */
export const HoverImage = (props) => {
    const { className, imageClassName = '', pictureClassName } = props, others = __rest(props
    // ホバー時の処理
    , ["className", "imageClassName", "pictureClassName"]);
    // ホバー時の処理
    const { boolState: isEnter, changeFalse: onMouseLeave, changeTrue: onMouseEnter, } = useBoolState({
        initialState: false,
    });
    return (_jsxs("div", Object.assign({ className: clsx(className) }, { children: [_jsx("div", Object.assign({ className: 'group/image', onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, { children: _jsx(ImageBase, Object.assign({ className: clsx('relative transition-transform duration-300', 'group-hover/image:shadow-md group-hover/image:scale-[1.3] group-hover/image:z-[1011]', 'group-hover/image:h-auto min-h-full', imageClassName), pictureClassName: clsx(pictureClassName) }, others)) })), isEnter && (_jsx("div", { className: clsx('fixed top-0 bottom-0 right-0 left-0 z-[1010]', 'bg-white bg-opacity-50', 'h-full w-full') }))] })));
};
